import { useEffect } from 'react';
import { getCookie } from '@/shared/lib/cookies';
import { tokenExpiresAtMs } from '@/shared/lib/jwt';
import { useAuthStore } from './store';

const AUTH_COOKIE = 'admin_auth_token';
const POLL_MS = 5_000;
const REFRESH_AHEAD_MS = 60_000;

/** Keeps access token fresh while the admin session is open (legacy AuthRefresher). */
export const AuthRefresher = () => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const authToken = useAuthStore((s) => s.profile.authToken);
  const refreshAccessToken = useAuthStore((s) => s.refreshAccessToken);
  const logout = useAuthStore((s) => s.logout);

  useEffect(() => {
    if (!isAuthenticated) return undefined;

    const tick = async () => {
      const token = authToken || getCookie(AUTH_COOKIE);
      const expiresAt = tokenExpiresAtMs(token);
      if (!expiresAt) return;
      if (expiresAt - Date.now() > REFRESH_AHEAD_MS) return;

      const next = await refreshAccessToken();
      if (!next) await logout();
    };

    const id = window.setInterval(() => {
      void tick();
    }, POLL_MS);
    void tick();

    return () => window.clearInterval(id);
  }, [isAuthenticated, authToken, refreshAccessToken, logout]);

  return null;
};
